export default __webpack_public_path__ + "static/media/chandal-mujer.26df0f87.png";